import {
  DEVICE_SENSOR_HISTORY_REQUEST,
  DEVICE_SENSOR_HISTORY_SUCCESS,
  DEVICE_SENSOR_HISTORY_ERROR
} from '../utils/app_constants';

const DEVICE_SENSOR_HISTORY_INITIAL_STATE = {};

export const deviceSensorHistoryReducer = (
  state = DEVICE_SENSOR_HISTORY_INITIAL_STATE,
  action
) => {
  switch (action.type) {
    case DEVICE_SENSOR_HISTORY_REQUEST:
      return {
        ...state,
        [action.deviceId]: {
          payload: {},
          isLoading: true,
          hasError: false
        }
      };
    case DEVICE_SENSOR_HISTORY_SUCCESS:
      return {
        ...state,
        [action.deviceId]: {
          isLoading: false,
          hasError: false,
          payload: { ...action.payload }
        }
      };
    case DEVICE_SENSOR_HISTORY_ERROR:
      return {
        ...state,
        [action.deviceId]: {
          isLoading: false,
          hasError: true,
          payload: { ...action.payload }
        }
      };
    default:
      return state;
  }
};
